import { io } from "socket.io-client";

const socket = io("https://notification-socket-273689773038.us-central1.run.app", {
  path: "/api/socket.io",
  transports: ["websocket"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  withCredentials: false,
});

export default socket;
